const global = window

inputs.types.upload = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.type == 'upload') {
        var uploadContainer = input.closest('.form--upload');
        if (data.vectorize) {
            uploadContainer.attr('data-vectorize', '1').data('vectorize', true);
        }
        if (data.open) {
            uploadContainer.attr('data-open', '1').data('open', true);
        }
        genericFormUpload(uploadContainer);
    }
    return data
}
